import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { trackEvent } from '../../../components/Analytics/TrackedClick';
import { getClickAttrs } from '../../../components/Analytics/gtag';
import { PowerFunnelGatedFeatures } from '../../../components/Analytics/constants';

import styles from './powerPerksPage.scss';

const HowPowerWorks = ({ auth, subscriptionPlans, isLoadingPlans, shouldShowPricing, onPowerClick }) => {
    const hasPastDueSubscription = auth?.user?.hasPastDueSubscription;

    // Get annual plan and pricing text directly
    const annualPlan = subscriptionPlans.find(plan => plan.interval === 'year');
    const pricingText = annualPlan?.displayMonthlyAmount
        ? `Pricing at ${annualPlan.displayMonthlyAmount}/mo.`
        : 'Pricing at $10/mo.';

    const handlePowerClick = () => {
        // segment call - mapped to GA4
        trackEvent(`Power Perks Power Lp Start Power Button Middle Click Segment`, {
            page: 'Home',
            button: 'Start Power Now',
            action: 'click',
        });
        onPowerClick(PowerFunnelGatedFeatures.HOW_POWER_WORKS);
    };

    return (
        <div className={styles.howPowerWorks}>
            <div className={styles.sectionTitle}>
                How Power works
            </div>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-6 offset-md-3">
                        <div className={`${styles.sectionDescription} mb56`}>
                            Power gets you access to deals, perks, and a whole lot more, before you even step onto the court.
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <div className={styles.card}>
                            <div className={styles.number}>1</div>
                            <div className={styles.title}>
                                Power up your account
                            </div>
                            <div className={styles.description}>
                                Start Power today and level up your playing experience
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className={styles.card}>
                            <div className={styles.number}>2</div>
                            <div className={styles.title}>
                                Unlock your Benefits
                            </div>
                            <div className={styles.description}>
                                Gain access to exclusive perks
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className={styles.card}>
                            <div className={styles.number}>3</div>
                            <div className={styles.title}>
                                Connect, Play and Save!
                            </div>
                            <div className={styles.description}>
                                Find level-based play near you, and save on verified fees
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 mt32">
                        {hasPastDueSubscription ? (
                            <Link
                                className="btn btn-lg btn-primary text-uppercase"
                                to="/subscriptions"
                                {...getClickAttrs({
                                    category: 'Resume Power',
                                    context: `Power Perks Power Lp Resume Power Button Middle Click`,
                                    location: 'Power Perks Power Lp',
                                })}
                            >
                                Resume Power
                            </Link>
                        ) : (
                            <div
                                className="btn btn-lg btn-primary text-uppercase"
                                onClick={handlePowerClick}
                                {...getClickAttrs({
                                    category: 'Power Upgrade',
                                    context: `Power Perks Power Lp Start Power Now Button Middle Click`,
                                    location: 'Power Perks Power Lp',
                                })}
                            >
                                Start Power Now
                            </div>
                        )}
                    </div>
                    <div className="col-12 mt8">
                        {shouldShowPricing && !isLoadingPlans && auth?.user && !hasPastDueSubscription && (
                            <small>{pricingText} Cancel anytime</small>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

HowPowerWorks.propTypes = {
    auth: PropTypes.shape({
        user: PropTypes.object,
    }).isRequired,
    subscriptionPlans: PropTypes.arrayOf(PropTypes.object).isRequired,
    isLoadingPlans: PropTypes.bool.isRequired,
    shouldShowPricing: PropTypes.bool.isRequired,
    onPowerClick: PropTypes.func.isRequired,
};

export default HowPowerWorks;
